import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'

import { App } from 'app/App'
import { msalConfig } from 'auth/config'
import { ApiProvider } from 'providers/ApiProvider'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

const msalInstance = new PublicClientApplication(msalConfig)

export const Root = () => (
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <div id="innovation-process-root">
        <ApiProvider>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </ApiProvider>
      </div>
    </MsalProvider>
  </StrictMode>
)
